module.exports = __webpack_public_path__ + "static/16-0561c8d863348a864a7bf81571ddc8ef.jpeg";